const faqs = [
  {
    question: 'How quickly do you ship? How long does shipping take?',
    answer:
      'I try to process all orders within 3 business days. Shipping usually takes between 5-7 business days, but can vary depending on USPS.',
  },
  {
    question: 'What do I do if my package gets lost in the mail',
    answer:
      "According to USPS, we must wait 30 days for domestic orders before filing a claim for the lost package. If you don't see any movement on your package within in the timeframe reach out and we can reship",
  },
  {
    question: 'I would like a custom order, is that possible?',
    answer:
      "At this time I don't offer custom orders. If I could send you all your own custom style I would do it.",
  },
  {
    question: 'Can I clean my earrings if I get something on them?',
    answer:
      'Things happen, I get it. If you get something on your earrings use a cotton swap with a little bit of rubbing alcohol and gently clean the earring.',
  },
  {
    question: 'What if my earrings break?',
    answer:
      "I try to be as understanding as possible with things breaking and want to provide good service. If your earrings break within 30 days of your purchase please let me know and I'll ship you a new pair.",
  },
];

export default faqs;
